import { clone } from '@/utils/helpers';
import { ScratchEventRSVPFormCampaign } from '@/types/resources/eventRSVPFormCampaign';
import { RegistrationFields, NewField, RegistrationRequiredFields } from '@/types/resources/genericCampaign'

export const initializeScratchEventRSVPForm = function (): ScratchEventRSVPFormCampaign {
  return { // It's 100% same as the real campaign object returned from backend, we have some attributes that just to make front-end's life easier
    name: 'Register for event',
    urlSlug: '',
    eventOid: null,
    type: 'rsvp',
    defaults: {},
    presentation: {
      successMessage: null,
      description: null,
      color: '#7344c0',
      headHtml: null,
      bodyHtml: null,
      metaTitle: null,
      metaDescription: null,
      noPoints: true,
      flow: ["register"],
      meta: null,
    },
    settings: {
      reminders: [
        {
          enabled: true,
          text: null,
          value: 5,
          unit: 'minutes',
        },
        {
          enabled: true,
          text: null,
          value: 24,
          unit: 'hours',
        }
      ],
    },
    startDate: null,
    endDate: null,
    promoterOid: null,
    registrations: {
      fields: [
        {
          name: 'Email address',
          key: 'emailAddress',
          optional: false,
          predefined: true,
          enabled: true,
          order: 0,
        },
        {
          name: 'First name',
          key: 'firstName',
          optional: false,
          predefined: true,
          enabled: true,
          order: 1,
        },
        {
          name: 'Last name',
          key: 'lastName',
          optional: false,
          predefined: true,
          enabled: true,
          order: 2,
        },
        {
          name: 'Mobile number',
          key: 'mobileNumber',
          optional: false,
          predefined: true,
          enabled: false,
          order: -1,
        },
        {
          name: 'Date of birth',
          key: 'dob',
          optional: false,
          predefined: true,
          enabled: false,
          order: -1,
        },
        {
          name: 'Gender',
          key: 'gender',
          optional: false,
          predefined: true,
          enabled: false,
          order: -1,
        },
        {
          name: 'Country',
          key: 'country',
          optional: false,
          predefined: true,
          enabled: false,
          order: -1,
        },
        {
          name: 'Zip/Post code',
          key: 'postcode',
          optional: false,
          predefined: true,
          enabled: false,
          order: -1,
        },
        {
          name: 'City',
          key: 'city',
          optional: false,
          predefined: true,
          enabled: false,
          order: -1,
        },
        {
          name: 'State',
          key: 'state',
          optional: false,
          predefined: true,
          enabled: false,
          order: -1,
        },
        {
          name: 'Street address',
          key: 'streetAddress',
          optional: false,
          predefined: true,
          enabled: false,
          order: -1,
        },
      ],
      providers: {
        email: true,
        spotify: false,
        facebook: false,
      },
    },
    resources: [],
  }
};

/**
 * This is the place that we can implement missing fileds or adjusting old fields
 * for RSVP Event.
 * @param eventRSVP
 */
export const correctScratchEventRSVPForm = function (eventRSVPForm: ScratchEventRSVPFormCampaign) {
  const scratchEventRSVPForm: ScratchEventRSVPFormCampaign = clone(eventRSVPForm);
  // Event RSVP always has no points
  scratchEventRSVPForm.presentation.noPoints = true;
  // Event RSVP always has email provider as true
  scratchEventRSVPForm.registrations.providers = {
    email: true,
    spotify: false,
  };
  return scratchEventRSVPForm;
}

export const patchAdvancedSettingsInEventRSVP = function (
  scratchEventRSVPForm: ScratchEventRSVPFormCampaign,
  advancedSettings: any,
) {
  const newScratchEventRSVPForm: ScratchEventRSVPFormCampaign = clone(scratchEventRSVPForm);

  if (advancedSettings && Object.keys(advancedSettings).length > 0) {
    newScratchEventRSVPForm.settings = {
      ...newScratchEventRSVPForm.settings,
      ...advancedSettings
    };
  }

  return newScratchEventRSVPForm;
}



export const convertRegistrationsObjectToArray = function(registrationFieldsObject:RegistrationFields):NewField[] {
  const keys = Object.keys(registrationFieldsObject).filter( key => key !== 'messenger'); // Remove messenger if its present
  const newFields:NewField[] = [];
  keys.forEach( key => {
    let name;
    let order;
    switch(key) {
      case "emailAddress":
        name = "Email address";
        order = 1;
        break;
      case "firstName":
        name = "First name";
        order = 2;
        break;
      case "lastName":
        name = "Last name";
        order = 3;
        break;
      case "mobileNumber":
        name = "Mobile number";
        order = 4;
        break;
      case "dob":
        name = "Date of birth";
        order = 5;
        break;
      case "gender":
        name = "Gender";
        order = 6;
        break;
      case "country":
        name = "Country";
        order = 7;
        break;
      case "postcode":
        name = "Postcode";
        order = 8;
        break;
      case "city":
        name = "City";
        order = 9;
        break;
      case "state":
        name = "State";
        order = 10;
        break;
      case "streetAddress":
        name = "Street Address";
        order = 11;
        break;
    }
    const newField = {
      name,
      key,
      order,
      predefined: true,
      // @ts-ignore
      optional: (key in registrationFieldsObject) && !!registrationFieldsObject[key].optional,
      // @ts-ignore
      enabled: (key in registrationFieldsObject) && !!registrationFieldsObject[key].enabled,
      isMandatory: key === 'emailAddress',
    }
    newFields.push(newField)
  });
  newFields.sort((a, b) => {
    return a.enabled ? -1 : 1;
  });
  newFields.sort((a, b) => {
    return a.order - b.order;
  });
  return newFields;
}